import { useEffect } from 'react';

type QueryTestParameters = {
  userId?: string;
};

const parameters: QueryTestParameters = {};

export function getQueryTestParameters() {
  return { ...parameters };
}

export function useReadQueryTestParameters() {
  useEffect(() => {
    // We use window.location instead of useLocation,
    // because we want to read the parameters only on the first load of the application,
    // and useLocation would trigger a re-render every time the location changes, which is not what we want.
    const userId = new URLSearchParams(window.location.search).get('userId');

    // We save it as a variable in memory and not in the session storage,
    // to avoid potential errors when trying to access the session storage.
    if (userId !== null) {
      // The value 'null' is used in the load test to indicate that there should be no user token.
      // In this case, we set the userToken to an empty string, which will be treated as no user token in the player configuration.
      parameters.userId = userId === 'null' ? '' : userId;
    }
  }, []);
}
